import React from 'react';
import PropTypes from 'prop-types';
import Countdown, { zeroPad } from 'react-countdown-now';

// Wrap each number in span
const Number = (rawNumber) => {
   const wrappedNumbers = rawNumber.split('').map((n, i) => (
      <span key={i} className="eventCountdown_digit">
         {n}
      </span>
   ));
   return <span className="eventCountdown_digits">{wrappedNumbers}</span>;
};

const renderer = ({ days, hours, minutes, seconds }) => {
   return (
      <div className="eventCountdown_countdown">
         <span className="eventCountdown_number">
            {Number(zeroPad(days, 3))}
            <span className="eventCountdown_unit">dager</span>
         </span>
         <span className="eventCountdown_divider">-</span>
         <span className="eventCountdown_number">
            {Number(zeroPad(hours))}
            <span className="eventCountdown_unit">timer</span>
         </span>
         <span className="eventCountdown_divider">-</span>
         <span className="eventCountdown_number">
            {Number(zeroPad(minutes))}
            <span className="eventCountdown_unit">minutter</span>
         </span>
         <span className="eventCountdown_divider">-</span>
         <span className="eventCountdown_number">
            {Number(zeroPad(seconds))}
            <span className="eventCountdown_unit">sekunder</span>
         </span>
      </div>
   );
};

class eventCountdown extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
         loaded: false
      };
   }

   componentDidMount() {
      this.setState({
         loaded: true
      });
   }

   render() {
      return (
         <Countdown
            completionText={this.props.completionText}
            date={this.props.endDate}
            renderer={renderer}
         />
      );
   }
}

eventCountdown.propTypes = {
   endDate: PropTypes.string.isRequired
};

export const Component = eventCountdown;
export default { Component };
